import { ACTION_TYPES, Actions } from "./types"
import { Action } from "./actions"

export const PROPOSAL_ACTION_TYPES = ACTION_TYPES
export const ProposalAction = Action
export type ProposalActions = Actions




// WEBPACK FOOTER //
// ./src/state/proposal/actions/index.ts